//SCSS
require("view/footer/Footer.scss");

const UIComponent = require("base/UIComponent");

//HTMLS:
const HTML = require("view/footer/Footer.html");

class Footer extends UIComponent {
    constructor() {
        super("#main", HTML, false);
    };

    show(){
        super.show();
    }

    hide(){
        super.hide();
    };

    pathChanged(l1, l2, l3){
        if(l1 === "app")
            this.ready = false;
        else{
            this.ready = true;
        }
    };
};

module.exports = Footer;



// WEBPACK FOOTER //
// ./src/view/footer/Footer.js